import { ApiCore } from "../../utilities/core";

const url = 'api/edge/retail/get_rentals_anlysis_chart';

export const apiRentalsAnalysisChart = new ApiCore({
    get: true,
    post: true,
    url: url
});